module.exports = __webpack_public_path__ + "static/media/Invita Logo.f61cc09a.svg";